import { Directive, DirectiveBinding } from 'vue'

const airbagDirective: Directive = {
  mounted: (el: HTMLElement, binding: DirectiveBinding) => {
    const airBagClass = 'airbag'
    const targetClass = binding.value.targetClass
    const targetAppendElement = el.closest('.' + targetClass) as HTMLElement

    if (targetAppendElement.querySelector('.' + airBagClass)) return
    const airbagElement = document.createElement('div')
    airbagElement.classList.add(airBagClass)
    targetAppendElement.appendChild(airbagElement)
  },
  updated: (el: HTMLElement, binding: DirectiveBinding) => {
    if (binding.value == binding.oldValue) return

    const airBagClass = 'airbag'
    const targetClass = binding.value.targetClass
    const targetAppendElement = el.closest('.' + targetClass) as HTMLElement
    const airbagElement = targetAppendElement.querySelector('.' + airBagClass) as HTMLDivElement
    const elementHeight = el.offsetHeight
    const oldHeight = parseInt(airbagElement.dataset.oldHeight || '0')

    if (elementHeight <= oldHeight) {
      airbagElement.style.height = oldHeight - elementHeight + 'px'
    } else {
      airbagElement.style.height = 0 + 'px'
      airbagElement.dataset.oldHeight = '0'
    }

    if (elementHeight > oldHeight) airbagElement.dataset.oldHeight = elementHeight.toString()

    if (window.IntersectionObserver) {
      const airbagObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            airbagElement.style.height = '0'
          }
        })
      })

      airbagObserver.observe(airbagElement)
    }
  }
}

export default airbagDirective
